import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Data, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { CatalogueItem } from '../model/catalogue-category/catalogue-item.model';
import * as fromApp from '../store/app.reducers';
import { IProduct } from '../model/contract/product.contract';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

interface IModalData {
    item: IProduct;
}

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductComponent implements OnInit {

    modalData: IModalData = inject(NZ_MODAL_DATA);

    @Input() inputCatalogueItem: IProduct;
    @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();

    catalogueItem: IProduct;
    container: 'dialog' | 'page';

    constructor(private route: ActivatedRoute,
        private router: Router,
        private store: Store<fromApp.AppState>,
        private location: Location) {
    }

    ngOnInit() {
        if (isInputItem(this.inputCatalogueItem)) {
            this.catalogueItem = this.inputCatalogueItem;
            this.container = 'dialog';
        } else if (isInputItem(this.modalData.item)) {
            this.catalogueItem = this.modalData.item;
            this.container = 'dialog';
        } else {
            this.container = 'page';
            this.route.data
                .subscribe(
                    (data: Data) => {
                        this.catalogueItem = data['product'];
                    }
                );
        }

    }

    toLastVisitedPage() {
        if (isInputItem(this.inputCatalogueItem)) {
            this.closeDialog.emit(true);
        } else {
            this.location.back();
        }
    }

    isSampling(item) {
        return item instanceof CatalogueItem;
    }
}

const isInputItem = (item: IProduct) => !(item === null || item === undefined);
